<div class="card mt-4" [class.border-danger]="showEmptyError">
  <div class="card-header font-weight-bold">Payment Condition</div>
  <div class="card-body">
    @if (showEmptyError) {
      <div class="alert alert-danger">
        <i class="fa fa-exclamation-triangle"></i>
        <strong>Payment Condition is required.</strong>
        Please add at least one payment condition by clicking the "Add Payment Condition" button below.
      </div>
    }
    @if (getPaymentConditionsArray().hasError('totalPercentExceeded')) {
      <div class="alert alert-danger">
        <i class="fa fa-exclamation-triangle"></i>
        Total payment percentage ({{ getPaymentConditionsArray().getError('totalPercentExceeded').actual }}%)
        exceeds 100%. Please adjust the percentages to exactly 100%.
      </div>
    }
    @if (getPaymentConditionsArray().hasError('totalPercentInsufficient')) {
      <div class="alert alert-danger"
        >
        <i class="fa fa-exclamation-triangle"></i>
        Total payment percentage ({{ getPaymentConditionsArray().getError('totalPercentInsufficient').actual }}%) is
        less than 100%. Please adjust the percentages to exactly 100%.
      </div>
    }

    @if (getPaymentConditionsArray().controls.length > 0 && formPaymentCondition) {
      <div class="table-responsive">
        <form [formGroup]="formPaymentCondition">
          <table class="table table-borderless mb-0 payment-table">
            <thead>
              <tr>
                <th style="width: 15%;">%</th>
                <th>Terms</th>
                <th style="width: 18%;">Partial</th>
                <th style="width: 60px;" class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              @for (paymentCondition of getPaymentConditionsArray().controls; track paymentCondition; let i = $index) {
                <tr>
                  <td>
                    <select-field [selectFormControl]="getFormControl(paymentCondition, 'percent')"
                      label="" [options]="ratesOptions"
                      [readonly]="readonlyPaymentCondition" />
                  </td>
                  <td>
                    <select-field
                      [selectFormControl]="getFormControl(paymentCondition, 'proposalPaymentConditionTypeId')"
                      label="" [options]="termsOptions"
                      [readonly]="readonlyPaymentCondition" />
                  </td>
                  <td>
                    <input-field type="text"
                      [inputFormControl]="getFormControl(paymentCondition, 'partial')"
                      [readonly]="true" label="" placeholder="Partial"
                      [readonly]="readonlyPaymentCondition" />
                  </td>
                  <td class="text-center align-middle">
                    <button type="button" class="btn btn-danger btn-sm"
                      [disabled]="readonlyPaymentCondition"
                      [ngClass]="{'disabled': readonlyPaymentCondition}"
                      (click)="confirmDelete(getPaymentConditionsArray(), i, 'Payment Condition')">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </form>
      </div>
    }

    @if (readonlyPaymentCondition === false) {
      <div class="mt-3">
        <button type="button" class="btn btn-primary" (click)="addNewPaymentCondition()">
          <i class="fa fa-plus"></i> Add Payment Condition
        </button>
      </div>
    }
  </div>
</div>